import { render, staticRenderFns } from "./version_badge.vue?vue&type=template&id=52318b01&scoped=true&"
import script from "./version_badge.vue?vue&type=script&lang=js&"
export * from "./version_badge.vue?vue&type=script&lang=js&"
import style0 from "./version_badge.vue?vue&type=style&index=0&id=52318b01&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52318b01",
  null
  
)

export default component.exports